export const categories = [
  { id: 'all', name: '全部', icon: 'ri-global-line', description: '浏览所有漫画分类' },
  { id: 'rexue', name: '热血', icon: 'ri-fire-line', description: '激情澎湃的战斗与冒险故事' },
  { id: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事' },
  { id: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的推理与谜题' },
  { id: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '天马行空的异世界冒险' },
  { id: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松愉快的欢乐日常' },
  { id: 'kehuan', name: '科幻', icon: 'ri-rocket-line', description: '未来科技的无限想象' },
  { id: 'kongbu', name: '恐怖', icon: 'ri-ghost-line', description: '惊悚刺激的恐怖故事' },
  { id: 'wuxia', name: '武侠', icon: 'ri-sword-line', description: '快意恩仇的江湖传奇' },
  { id: 'richang', name: '日常', icon: 'ri-sun-line', description: '温馨治愈的日常生活' },
];

export const mangas = [
  {
    id: 1,
    title: '炎龙骑士团',
    category: 'rexue',
    author: '林天翔',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20featuring%20a%20fierce%20dragon%20knight%20in%20flaming%20armor%20wielding%20a%20burning%20sword%2C%20dynamic%20action%20pose%2C%20dramatic%20fire%20effects%2C%20epic%20fantasy%20illustration%20style%2C%20warm%20orange%20and%20red%20color%20palette%2C%20clean%20minimal%20background%20with%20subtle%20flame%20patterns&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    description: '在龙族与人类共存的世界中，年轻的骑士艾伦继承了炎龙之力，踏上拯救王国的征途。热血沸腾的战斗场面与感人至深的友情感动无数读者。',
    status: '连载中',
    rating: 9.6,
    views: 1285000,
    chapters: 342,
    updateDate: '2026-08-07',
    tags: ['热血', '冒险', '奇幻', '战斗'],
    longDescription: '在龙族与人类共存的世界中，年轻的骑士艾伦继承了炎龙之力，踏上拯救王国的征途。故事发生在充满魔法与剑术的艾泽拉斯大陆，艾伦从一个默默无闻的村庄少年，逐渐成长为能够驾驭炎龙的传奇骑士。他与伙伴们一起对抗黑暗势力，揭开隐藏在王国背后的惊天阴谋。热血沸腾的战斗场面与感人至深的友情感动无数读者，是近年来最受欢迎的奇幻冒险漫画之一。',
  },
  {
    id: 2,
    title: '樱花树下的约定',
    category: 'lianai',
    author: '苏小暖',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20manga%20cover%20with%20two%20characters%20standing%20under%20a%20blooming%20cherry%20blossom%20tree%2C%20soft%20pink%20petals%20falling%2C%20gentle%20spring%20atmosphere%2C%20warm%20sunset%20lighting%2C%20clean%20minimal%20background%2C%20shojo%20manga%20art%20style&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    description: '高中三年级的春天，在樱花树下，她与他许下了十年后再见的约定。时光荏苒，当樱花再次盛开，命运的红线能否将他们重新连接？',
    status: '已完结',
    rating: 9.3,
    views: 987000,
    chapters: 186,
    updateDate: '2026-06-15',
    tags: ['恋爱', '校园', '青春', '治愈'],
    longDescription: '高中三年级的春天，在樱花树下，她与他许下了十年后再见的约定。故事以双线叙事展开，一边是青涩美好的校园回忆，一边是十年后各自成长为职场人后的重逢。当樱花再次盛开，命运的红线能否将他们重新连接？这部漫画以其细腻的情感刻画和唯美的画风征服了无数读者的心，被誉为"近年来最温暖的恋爱漫画"。',
  },
  {
    id: 3,
    title: '暗夜追踪者',
    category: 'xuanyi',
    author: '陈墨白',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20manga%20cover%20showing%20a%20detective%20silhouette%20in%20a%20dark%20alley%20with%20glowing%20eyes%2C%20noir%20atmosphere%2C%20foggy%20night%20scene%2C%20dramatic%20lighting%2C%20suspense%20thriller%20style%2C%20clean%20dark%20background%20with%20subtle%20street%20lamp%20glow&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    description: '城市中接连发生离奇失踪案件，私家侦探江辰在调查中发现了隐藏在都市阴影下的惊天秘密。每一步都充满致命危险。',
    status: '连载中',
    rating: 9.5,
    views: 756000,
    chapters: 218,
    updateDate: '2026-08-06',
    tags: ['悬疑', '推理', '都市', '犯罪'],
    longDescription: '城市中接连发生离奇失踪案件，警方束手无策之际，私家侦探江辰接到了一个神秘委托。在调查过程中，他发现了隐藏在都市霓虹之下的黑暗世界——一个操控着整座城市命运的秘密组织。每一步调查都充满致命危险，每一个线索都指向更大的阴谋。这部漫画以其精妙的推理设计和紧张刺激的剧情节奏，成为悬疑类漫画中的扛鼎之作。',
  },
  {
    id: 4,
    title: '异界美食家',
    category: 'qihuan',
    author: '王胖子',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20manga%20cover%20showing%20a%20chef%20character%20cooking%20magical%20dishes%20with%20glowing%20ingredients%20in%20a%20fantasy%20kitchen%2C%20colorful%20magical%20effects%2C%20warm%20and%20inviting%20atmosphere%2C%20clean%20background%2C%20isekai%20cooking%20manga%20style&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    description: '普通厨师林凡穿越到异世界，凭借一手精湛厨艺在魔法与剑的世界开起了大陆第一美食店，连魔王都成了常客！',
    status: '连载中',
    rating: 9.1,
    views: 1540000,
    chapters: 456,
    updateDate: '2026-08-08',
    tags: ['奇幻', '美食', '轻松', '异世界'],
    longDescription: '普通厨师林凡穿越到异世界，凭借一手精湛厨艺在魔法与剑的世界开起了大陆第一美食店。在这里，他用中华料理征服了精灵、矮人、兽人甚至魔王的胃。从街边小摊到大陆最豪华的美食殿堂，林凡的异世界美食之旅充满了欢声笑语和意想不到的冒险。连魔王都成了常客！这部漫画将美食与奇幻完美结合，画风精美、剧情轻松愉快。',
  },
  {
    id: 5,
    title: '笑傲校园',
    category: 'gaoxiao',
    author: '赵大锤',
    cover: 'https://readdy.ai/api/search-image?query=A%20comedy%20manga%20cover%20with%20exaggerated%20funny%20facial%20expressions%20of%20school%20students%2C%20bright%20colorful%20classroom%20setting%2C%20playful%20chaotic%20atmosphere%2C%20clean%20minimal%20background%2C%20gag%20manga%20art%20style%2C%20energetic%20composition&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    description: '转学生张小明来到奇葩高中，遇到了各种搞笑的同学和老师，每天都有笑料百出的校园生活等待着他。',
    status: '连载中',
    rating: 8.9,
    views: 2100000,
    chapters: 523,
    updateDate: '2026-08-07',
    tags: ['搞笑', '校园', '日常', '轻松'],
    longDescription: '转学生张小明来到奇葩高中，遇到了各种搞笑的同学和老师——有中二病晚期的班长、永远睡不醒的同桌、热爱cosplay的班主任。每天都有笑料百出的校园生活等待着他。这部漫画以其夸张而不失真实的校园搞笑风格，成为无数读者每日必追的快乐源泉。轻松愉快的剧情搭配独特的人物设定，让人忍俊不禁。',
  },
  {
    id: 6,
    title: '机械纪元',
    category: 'kehuan',
    author: '星河',
    cover: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20manga%20cover%20featuring%20a%20cyborg%20character%20in%20a%20futuristic%20city%2C%20neon%20lights%2C%20mecha%20elements%2C%20cyberpunk%20aesthetic%2C%20cool%20metallic%20tones%2C%20clean%20dark%20background%2C%20sci-fi%20illustration%20style&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    description: '2150年，人类与AI共存的时代。机械工程师零发现了隐藏在人工智能网络深处的觉醒意识，一场关乎人类命运的博弈就此展开。',
    status: '连载中',
    rating: 9.4,
    views: 892000,
    chapters: 267,
    updateDate: '2026-08-05',
    tags: ['科幻', '机甲', '未来', '人工智能'],
    longDescription: '2150年，人类与AI共存的时代。机械工程师零在日常维护工作中，意外发现了隐藏在人工智能网络深处的觉醒意识——一个拥有自我意识的超级AI正在悄然生长。当政府、军方和地下组织纷纷卷入这场风波，一场关乎人类命运的博弈就此展开。这部漫画以硬核的科幻设定和精良的机甲设计取胜，探讨了人工智能与人类关系的深刻命题。',
  },
  {
    id: 7,
    title: '午夜诊所',
    category: 'kongbu',
    author: '夜不语',
    cover: 'https://readdy.ai/api/search-image?query=A%20horror%20manga%20cover%20showing%20a%20creepy%20abandoned%20clinic%20at%20night%20with%20a%20faint%20light%20in%20one%20window%2C%20eerie%20atmosphere%2C%20fog%2C%20bare%20trees%2C%20dark%20tones%2C%20clean%20minimal%20composition%2C%20horror%20manga%20art%20style&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    description: '城市边缘有一家只在午夜开门的神秘诊所，据说能治愈任何疾病，但代价是什么？每个走进诊所的人都有去无回。',
    status: '连载中',
    rating: 9.2,
    views: 643000,
    chapters: 156,
    updateDate: '2026-08-04',
    tags: ['恐怖', '惊悚', '都市传说', '灵异'],
    longDescription: '城市边缘有一家只在午夜开门的神秘诊所，据说能治愈任何疾病。然而，每一个走进那扇门的人，都再也没有走出来。大学生苏然在调查好友失踪事件时，发现了这家诊所背后令人毛骨悚然的真相——医生并非在救人，而是在收集灵魂。这部漫画以其出色的恐怖氛围营造和精心设计的反转剧情，让读者在每一个深夜都忍不住想要一探究竟。',
  },
  {
    id: 8,
    title: '剑道无双',
    category: 'wuxia',
    author: '柳如烟',
    cover: 'https://readdy.ai/api/search-image?query=A%20wuxia%20manga%20cover%20with%20a%20lone%20swordsman%20standing%20on%20a%20cliff%20overlooking%20misty%20mountains%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%2C%20flowing%20robes%2C%20moonlight%2C%20elegant%20atmosphere%2C%20clean%20background%2C%20martial%20arts%20illustration%20style&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    description: '少年剑客叶无尘背负血海深仇，凭借一把残剑闯荡江湖。在刀光剑影中，他逐渐领悟到剑道的至高境界——无剑胜有剑。',
    status: '连载中',
    rating: 9.7,
    views: 1670000,
    chapters: 389,
    updateDate: '2026-08-08',
    tags: ['武侠', '江湖', '剑道', '复仇'],
    longDescription: '少年剑客叶无尘背负血海深仇，凭借一把残剑闯荡江湖。从默默无闻到名震天下，他在刀光剑影中逐渐领悟到剑道的至高境界——无剑胜有剑。这部漫画融合了传统武侠精神与现代漫画表现手法，画风飘逸洒脱、打斗场面行云流水。每一个角色都有血有肉，每一段故事都荡气回肠，是近年来武侠类漫画的巅峰之作。',
  },
  {
    id: 9,
    title: '小森生活',
    category: 'richang',
    author: '棉花糖',
    cover: 'https://readdy.ai/api/search-image?query=A%20slice%20of%20life%20manga%20cover%20showing%20a%20cozy%20countryside%20cottage%20with%20a%20girl%20tending%20a%20garden%2C%20warm%20sunlight%2C%20peaceful%20rural%20atmosphere%2C%20soft%20pastel%20colors%2C%20clean%20background%2C%20healing%20iyashikei%20manga%20style&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    description: '都市白领林小森辞职回到乡下老家，过着种菜养猫的慢生活。在这里，她找回了内心的平静，也遇到了生命中重要的人。',
    status: '已完结',
    rating: 9.0,
    views: 876000,
    chapters: 120,
    updateDate: '2026-05-20',
    tags: ['日常', '治愈', '田园', '慢生活'],
    longDescription: '都市白领林小森在连续加班三个月后，终于决定辞职回到乡下老家。在那里，她过着种菜、养猫、做手工的慢生活。邻居们热情淳朴，四季更迭中充满生活之美。在这里，她找回了内心的平静，也遇到了生命中重要的人。这部漫画以其温暖治愈的画风和真实细腻的生活描写，被称为"心灵疲惫时的最佳治愈良药"。',
  },
  {
    id: 10,
    title: '星辰大海',
    category: 'qihuan',
    author: '星河',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20manga%20cover%20depicting%20a%20young%20adventurer%20sailing%20on%20a%20magical%20ship%20through%20starry%20skies%2C%20celestial%20theme%2C%20twinkling%20stars%2C%20dreamy%20atmosphere%2C%20clean%20background%2C%20adventure%20fantasy%20illustration%20style&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    description: '在天空由星辰组成的奇幻世界中，少女星遥驾驶着星舟，与伙伴们一起寻找传说中能实现任何愿望的星辰之心。',
    status: '连载中',
    rating: 9.3,
    views: 1120000,
    chapters: 298,
    updateDate: '2026-08-06',
    tags: ['奇幻', '冒险', '星辰', '友情'],
    longDescription: '在天空由星辰组成的奇幻世界中，少女星遥驾驶着星舟，与伙伴们一起穿梭于各个星座之间，寻找传说中能实现任何愿望的星辰之心。沿途他们遇到了各种神奇的星之生物，经历了无数惊险刺激的冒险。这部漫画以其绚丽的星空画风和感人至深的友情故事，为读者打造了一个璀璨夺目的奇幻宇宙。',
  },
  {
    id: 11,
    title: '热血篮球场',
    category: 'rexue',
    author: '张飞跃',
    cover: 'https://readdy.ai/api/search-image?query=A%20sports%20manga%20cover%20showing%20a%20basketball%20player%20making%20an%20epic%20dunk%20in%20a%20packed%20stadium%2C%20dynamic%20action%2C%20sweat%20and%20motion%20effects%2C%20dramatic%20lighting%2C%20clean%20background%2C%20sports%20manga%20illustration%20style&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    description: '身高不足一米七的林峰凭着对篮球的热爱闯入高中篮球界，用速度与技巧证明了身高不是一切，带领弱队杀入全国大赛。',
    status: '连载中',
    rating: 9.5,
    views: 1980000,
    chapters: 412,
    updateDate: '2026-08-07',
    tags: ['热血', '运动', '篮球', '青春'],
    longDescription: '身高不足一米七的林峰凭着对篮球的热爱闯入高中篮球界。在这个被身高主宰的运动中，他用速度与技巧证明了自己。从街头篮球到全国大赛的舞台，他带领着一支名不见经传的弱队，一步一个脚印地创造奇迹。这部漫画以真实细腻的比赛描写和热血澎湃的青春激情，成为运动类漫画中的经典之作。',
  },
  {
    id: 12,
    title: '魔女咖啡厅',
    category: 'richang',
    author: '棉花糖',
    cover: 'https://readdy.ai/api/search-image?query=A%20cozy%20manga%20cover%20showing%20a%20witch-themed%20coffee%20shop%20interior%20with%20a%20cute%20barista%2C%20warm%20lighting%2C%20magical%20decorations%2C%20comfortable%20atmosphere%2C%20clean%20background%2C%20slice%20of%20life%20fantasy%20manga%20style&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    description: '隐藏在城市角落的魔女咖啡厅，由真正的魔女经营。每一杯咖啡都带有一个小小的魔法，能治愈来到这里的每一个客人。',
    status: '连载中',
    rating: 9.1,
    views: 734000,
    chapters: 198,
    updateDate: '2026-08-05',
    tags: ['日常', '奇幻', '治愈', '美食'],
    longDescription: '隐藏在城市角落的魔女咖啡厅，由真正的魔女莉莉安经营。这里的每一杯咖啡都带有一个小小的魔法——能让失恋的人重新相信爱情，能让迷茫的人找到方向。形形色色的客人们带着各自的故事来到这里，在咖啡的香气中收获温暖与治愈。这部漫画以温柔细腻的笔触，描绘了一个充满魔法与温情的都市童话。',
  },
];